'use client'

import { Controller, useForm } from 'react-hook-form'
import { useAuth } from '@/providers/auth.provider'
import { Button } from '@/components/ui/button'
import Input from '@/components/Input'
import { Routes } from '@/config/routes.config'

interface UserLoginDetails {
  email: string
}

const EmailForm = () => {
  const { sendOTP } = useAuth()

  const { control, handleSubmit } = useForm<UserLoginDetails>({ mode: 'all' })

  const submit = async (data: UserLoginDetails) => {
    await sendOTP(data.email)
  }

  return (
    <form className="space-y-8" onSubmit={handleSubmit(submit)}>
      <Controller
        name="email"
        control={control}
        defaultValue=""
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => (
          <Input
            label="Email"
            placeholder="me@email.com"
            onChange={field.onChange}
            value={field.value}
            error={error}
          />
        )}
      />
      <div className="flex flex-col gap-2">
        <Button
          variant="default"
          onClick={handleSubmit(submit)}
          className="w-full"
        >
          Continuer
        </Button>
      </div>
    </form>
  )
}

export default EmailForm
